var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"sg-header"},[_c('container',{staticClass:"header__container"},[_c('a',{staticClass:"header__logo",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"/images/shirtigo-logo-color.svg","alt":"Shirtigo"}})]),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }